import { BrowserRouter, Routes, Route } from 'react-router-dom';

import Navbar from './components/Navbar/Navbar';

import Inicio from './pages/Inicio/Inicio';
import SobreMi from './pages/SobreMi/SobreMi';
import Servicios from './pages/Servicios/Servicios';
import Testimonios from './pages/Testimonios/Testimonios';
import Blog from './pages/Blog/Blog';
import Contacto from './pages/Contacto/Contacto';
import Footer from './components/Footer/Footer';
import AvisoLegal from './pages/AvisoLegal/AvisoLegal';
import Privacidad from './pages/Privacidad/Privacidad';
import Cookies from './pages/Cookies/Cookies';

import './App.css';

function App() {
  return (
    <BrowserRouter>
      <Navbar />

      <main>
        <Routes>
          <Route path="/" element={<Inicio />} />
          <Route path="/sobre-mi" element={<SobreMi />} />
          <Route path="/servicios" element={<Servicios />} />
          <Route path="/testimonios" element={<Testimonios />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/contacto" element={<Contacto />} />
          <Route path="/aviso-legal" element={<AvisoLegal />} />
          <Route path="/privacidad" element={<Privacidad />} />
          <Route path="/cookies" element={<Cookies />} />
        </Routes>
      </main>
      <Footer />
    </BrowserRouter>
  );
}

export default App;
